<nav class="gb-nav" aria-label="Main">
  <div class="gb-shell">
    <a class="nav-brand" [routerLink]="AppRoutes.home()" aria-label="GiveBrite home">
      <img class="nav-logo" [src]="platformLogoSrc" alt="givebrite" />
    </a>

    <ng-container *featureFlag="'header_search_is_enabled'">
      <div class="flex-1 flex justify-center px-4 max-sm:hidden">
        <gb-header-platform-search
          class="!w-full !max-w-[480px]"
          [light]="!transparent"
        ></gb-header-platform-search>
      </div>
    </ng-container>

    <div class="flex items-center gap-3 ml-auto">
      <div class="relative max-sm:hidden">
        <ui-button
          variant="primary"
          size="md"
          ariaLabel="Fundraise with AI"
          (buttonClick)="fundraiseWithAi()"
        >
          <span class="inline-flex items-center gap-2">
            <ui-icon name="sparkles" [size]="14"></ui-icon>
            Fundraise with AI
          </span>
        </ui-button>
        <span
          class="badge badge-sm h-[22px] px-[9px] rounded-full border-none bg-[color-mix(in_oklab,var(--color-purple)_15%,white)] text-xs font-extrabold text-[color-mix(in_srgb,var(--color-purple)_60%,var(--color-ink))] absolute -top-[11px] -right-1.5 z-[2]"
          >New</span
        >
      </div>

      <div class="max-sm:hidden">
        @if (menuOpen) {
          <button
            type="button"
            class="fixed inset-0 z-[55] cursor-default bg-transparent"
            aria-label="Close menu"
            (click)="closeMenu()"
          ></button>
        }
        <div class="dropdown dropdown-end z-[60]" [class.dropdown-open]="menuOpen">
          <!-- DaisyUI disables pointer events on a focused dropdown trigger, which swallows the click. -->
          <button
            type="button"
            tabindex="0"
            class="btn btn-ghost btn-square nav-burger !pointer-events-auto !relative !z-[70]"
            [attr.aria-label]="menuOpen ? 'Close menu' : 'Open menu'"
            [attr.aria-expanded]="menuOpen"
            (click)="toggleMenu()"
          >
            <ui-icon
              [name]="menuOpen ? 'x' : 'menu'"
              [size]="24"
              [color]="transparent && !menuOpen ? 'white' : 'currentColor'"
            ></ui-icon>
          </button>
          <div
            tabindex="0"
            [class.hidden]="!menuOpen"
            class="dropdown-content bg-base-100 text-base-content rounded-3xl z-[60] mt-2 w-[min(100vw-1.5rem,20rem)] max-h-[calc(100vh-6rem)] overflow-y-auto p-0 shadow-xl border border-base-200"
          >
            <gb-header-platform-menu (closed)="closeMenu()"></gb-header-platform-menu>
          </div>
        </div>
      </div>

      <div class="drawer drawer-end sm:hidden">
        <input
          id="gb-platform-mobile-drawer"
          type="checkbox"
          class="drawer-toggle"
          [checked]="menuOpen"
          (change)="toggleMenu()"
        />

        <div class="drawer-content flex justify-end">
          <button
            type="button"
            class="btn btn-ghost btn-square nav-burger"
            [attr.aria-label]="menuOpen ? 'Close menu' : 'Open menu'"
            [attr.aria-expanded]="menuOpen"
            (click)="toggleMenu()"
          >
            <ui-icon
              [name]="menuOpen ? 'x' : 'menu'"
              [size]="24"
              [color]="transparent && !menuOpen ? 'white' : 'currentColor'"
            ></ui-icon>
          </button>
        </div>

        <div class="drawer-side z-[60]">
          <label
            for="gb-platform-mobile-drawer"
            aria-label="Close menu"
            class="drawer-overlay"
          ></label>
          <div class="bg-base-100 text-base-content min-h-full w-9/10 shadow-xl">
            <gb-header-platform-menu (closed)="closeMenu()"></gb-header-platform-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
